var React = require('react');
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var withRouter = require('react-router').withRouter;

var CategoryNav = createReactClass({

	handleChange: function(e){
		this.props.router.push('/blog/' + e.currentTarget.value);
	},

	getCategoryDisplayName: function(){
		var activeCategory = this.props.categories.filter(function(category){
			return category.friendlyUrl === this.props.categorySlug;
		}.bind(this))[0];

		return activeCategory ? activeCategory.displayName : '';
	},

	render: function () {
		var linkNodes = this.props.categories.map(function(category){
			return <li key={category.friendlyUrl}><Link to={'/blog/' + category.friendlyUrl} className={this.props.categorySlug === category.friendlyUrl ? 'active' : ''}>{category.displayName}</Link></li>
		}.bind(this));

		var optionNodes = this.props.categories.map(function(category){
			return <option key={category.friendlyUrl} value={category.friendlyUrl}>{category.displayName}</option>
		});

        return (
			<nav className="category-nav">
				<p>Categories</p>
				<div className="special-select show-for-small-only">
					<select onChange={this.handleChange} value={this.props.categorySlug}>
						{optionNodes}
					</select>
					<span className="ion-ios-arrow-down"></span>

					<span className="current-option">{this.getCategoryDisplayName()}</span>
				</div>

				<ul className="no-bullet show-for-medium">
					{linkNodes}
				</ul>
			</nav>
        );
    }
});

module.exports = withRouter(CategoryNav);



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/categoryNav.jsx